import React from 'react';
import { IconsPros } from './types';

/**
 * Undo Icon component
 *
 * @returns JSX.ELEMENT
 */
export const UndoIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M15.92,11.34c-1.36-2.63-4-5.74-8.56-6a.65.65,0,0,1-.61-.65V2.94a.63.63,0,0,0-1.06-.48l-5.48,5a.66.66,0,0,0,0,1l5.48,5.15a.63.63,0,0,0,1.06-.48v-2.2a.64.64,0,0,1,.64-.64c3,0,5.55.33,7.57,1.93A.64.64,0,0,0,15.92,11.34Z" />
    </svg>
  );
};
